import { render } from "./WaitingModal.vue?vue&type=template&id=5f7de29c"
import script from "./WaitingModal.vue?vue&type=script&lang=js"
export * from "./WaitingModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__